/**
 * 状态对象模块
 * */
const state = {
    // 购物车的商品
    shopCart: {},
    // 用户信息
    userInfo: {},
    isLogin: false,
    round: 1,
}

export default state;


// WEBPACK FOOTER //
// ./src/store/state.js